export const SHOW_MAIN_MENU_CAROUSEL_HEADER = false;
